var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChargeGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95135 2.80359H12.8895C13.2565 2.80359 13.4985 3.1858 13.3414 3.51752L10.9406 8.5893H13.7863C14.2277 8.5893 14.4526 9.11947 14.1458 9.43681L6.88728 16.9457C6.53566 17.3094 5.9281 16.9807 6.04022 16.4873L7.11199 11.7715C7.1831 11.4587 6.94529 11.1607 6.62442 11.1607H4.12216H4.12168C3.77079 11.1607 3.52905 10.8087 3.65501 10.4812L6.48468 3.1241C6.55895 2.931 6.74447 2.80359 6.95135 2.80359Z",
    fill: "#6E777C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeGray);
export default __webpack_public_path__ + "static/media/charge-gray.6fa12d228eaf657aedccc11a6bdc0fce.svg";
export { ForwardRef as ReactComponent };